package com.happyukrainian.revision.kweb.pages.routes

import androidx.compose.runtime.Composable
import com.happyukrainian.revision.kweb.config.ButtonStyle
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.percent
import practicetest.Topic

@Composable
fun TopicRoute(topics: List<Topic>, onSelectTopic: (Topic) -> Unit) {
    Column(modifier = Modifier.fillMaxWidth().fillMaxHeight(), horizontalAlignment = Alignment.CenterHorizontally) {
        if (topics.isEmpty()) {
            SpanText("Loading...")
        } else {
            topics.forEach { topic ->
                Button(
                    modifier = ButtonStyle.toModifier().width(80.percent),
                    onClick = {
                        onSelectTopic(topic)
                    }) {
                    SpanText(topic.name)
                }
            }
        }
    }
}